import { useQuery, UseQueryResult } from 'react-query';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';


const useGetCustomFieldSelectData = (
  identifier: string,
): UseQueryResult<ApiResponse<any>, ApiError<any>> => {
  const queryParams = new URLSearchParams();

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery<ApiResponse<any>, ApiError<any>>(
    [`custom_fields_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}custom-fields/by-name`),
  );
};

export default useGetCustomFieldSelectData;
